<template>
  <div class="event-info text-justify">
    <slot name="header">default header</slot>
    <mdb-collapse :toggleTag="['span']" :togglers="1" :toggleClass="['toggle']" :toggleText="['']">
      <slot name="body">default body</slot>
    </mdb-collapse>
  </div>
</template>

<script>
import { mdbCollapse } from "mdbvue";

export default {
  name: "EventInfo",
  components: {
    mdbCollapse
  }
};
</script>

<style lang="scss">
.event-info {
  position: relative;
  color: #fff;
  background: gray;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 32px;
  margin: 24px 0;
  padding: 32px;
  padding-bottom: 48px;

  a {
    color: #fff;
    font-weight: 400;
    text-decoration: underline;
  }

  .event-text {
    width: 80%;
    max-width: 480px;
    margin-bottom: 16px;
  }

  .toggle {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 16px;
    margin: auto;
    display: block;
    margin: auto;
    width: 32px;
    height: 32px;
    background: url("../assets/expand-arrow.svg");
    background-size: contain;
  }

  .toggle:last-child {
    -moz-transform: scaleY(-1);
    -o-transform: scaleY(-1);
    -webkit-transform: scaleY(-1);
    transform: scaleY(-1);
  }
}
</style>